/* eslint-disable @typescript-eslint/no-explicit-any */

import { OpalApiResponseDocument } from '../schema'

function lookupInclude(relationship: any, included?: any[]): any {
  const found = (included || []).find(
    (include) =>
      include &&
      relationship &&
      include.id === relationship.id &&
      include.type === relationship.type
  )
  if (found && found.relationships) {
    Object.keys(found.relationships).forEach((relationKey) => {
      found.attributes[relationKey] = parseJSONApiDatum(
        lookupIncludes(found.relationships[relationKey], included),
        included
      )
    })
  }
  return found
}

function lookupIncludes(relationship: any, included: any): any {
  if (Array.isArray(relationship)) {
    return relationship.map((relation) =>
      lookupInclude(relation.data, included)
    )
  }
  if (Array.isArray(relationship.data)) {
    return relationship.data.map((relation: any): any =>
      lookupInclude(relation, included)
    )
  }
  return lookupInclude(relationship.data, included)
}

function makeFinalDatum(datum: any): any {
  if (datum) {
    return {
      id: datum.id,
      ...datum.attributes,
    }
  }
  return null
}

function parseJSONApiDatum(datum: any, included: any): any {
  if (!datum) {
    return null
  }
  if (Array.isArray(datum)) {
    return datum.map((data) => makeFinalDatum(data))
  }
  const finalDatum = makeFinalDatum(datum)
  return Object.keys(datum.relationships || []).reduce(
    (accum, current) => ({
      ...accum,
      [current]: parseJSONApiDatum(
        lookupIncludes(datum.relationships[current], included),
        included
      ),
    }),
    finalDatum
  )
}

export function parseJSONApiResponse({
  data,
  included,
}: OpalApiResponseDocument<any, any>) {
  if (Array.isArray(data)) {
    return data.map((datum) => parseJSONApiDatum(datum, included))
  }
  return parseJSONApiDatum(data, included)
}

export default parseJSONApiResponse
